module.exports = __webpack_public_path__ + "static/media/Appakara7.3a5adc01.jpg";